import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    // Tabs live at the root — URLs are /identify, /tyres, /garage… with no
    // /tabs/ furniture. Legacy /tabs/* links (old emails, Stripe return URLs,
    // shared links) redirect below.
    path: '',
    loadComponent: () => import('./pages/tabs/tabs.page').then((m) => m.TabsPage),
    children: [
      {
        path: 'identify',
        title: 'Identify · Vekkle',
        loadComponent: () => import('./pages/identify-car/identify-car.page').then((m) => m.IdentifyCarPage),
      },
      {
        path: 'tyres',
        title: 'Tyres · Vekkle',
        loadComponent: () => import('./pages/tyres/tyres.page').then((m) => m.TyresPage),
      },
      {
        path: 'damage',
        title: 'Damage · Vekkle',
        loadComponent: () => import('./pages/damage/damage.page').then((m) => m.DamagePage),
      },
      {
        path: 'parts',
        title: 'Parts · Vekkle',
        loadComponent: () => import('./pages/parts/parts.page').then((m) => m.PartsPage),
      },
      {
        path: 'garage',
        title: 'Garage · Vekkle',
        loadComponent: () => import('./pages/garage/garage.page').then((m) => m.GaragePage),
      },
      {
        path: 'garage/compare',
        title: 'Compare · Vekkle',
        loadComponent: () => import('./pages/garage/garage-compare.page').then((m) => m.GarageComparePage),
      },
      {
        path: 'garage/:id',
        title: 'Garage · Vekkle',
        loadComponent: () => import('./pages/garage/garage-detail.page').then((m) => m.GarageDetailPage),
      },
      { path: '', redirectTo: 'identify', pathMatch: 'full' },
    ],
  },
  {
    path: 'profile',
    title: 'Profile · Vekkle',
    loadComponent: () => import('./pages/profile/profile.page').then((m) => m.ProfilePage),
  },
  // Legacy /tabs/* deep links keep working forever.
  { path: 'tabs/garage/:id', redirectTo: 'garage/:id' },
  { path: 'tabs/:page', redirectTo: ':page' },
  { path: 'tabs', redirectTo: 'identify', pathMatch: 'full' },
  { path: '**', redirectTo: 'identify' },
];
